module.exports = "textarea.long_desc_area {\n    min-height: 100px;\n}\n\n.upload-image-form {\n    margin-bottom: 20px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/add-product/add-product.component.css
// module id = ./src/app/add-product/add-product.component.css
// module chunks = main